// extracted by mini-css-extract-plugin
export var blockedMessage = "_8p-3";
export var blockedOverlay = "_8p-1";
export var fadeIn = "_8p-2";
export var hereLink = "_8p-0";
export var slideUp = "_8p-4";